<template>
  <el-dialog title="解析详情" @close="close" width="60%" class="newlyadd">
    <h-table
      ref="tableRef"
      v-model:data="tableData"
      v-model:columns="columns"
      :method="analysisdetail"
      :params="tableParams"
      class="table"
      @select="hzTableSelect"
    >
      <template #analysisProgress="{ row }">
        <div>
          <div>
            任务时段:<span>{{
              row.analysing[0].startTime + "~" + row.analysing[0].endTime
            }}</span>
          </div>
          <div>解析时段:</div>
          <div>任务进度:{{ row.analysisProgress }} %</div>
          <div>
            解析结果:
            <div>
              人脸：{{ row.faceSnapCount }} 非机动车：{{
                row.nonVehicleCount
              }}
              人体：{{ row.personCount }} 机动车：{{ row.vehicleCount }}
            </div>
          </div>
        </div>
      </template>
      <template #downloadStatus="{ row }">
        <span>{{ row.downloadStatus === "0" ? "完成" : "未完成" }}</span>
      </template>
      <template #analysisStatus="{ row }">
        <!-- 0-等待;1-运行;2-异常;3-暂停;4-完成) -->
        <span>{{
          row.analysisStatus === "1"
            ? "等待"
            : row.analysisStatus === "2"
            ? "异常"
            : row.analysisStatus === "3"
            ? "暂停"
            : "完成"
        }}</span>
      </template>
      <template #operate="{ row }">
        <h-button type="primary" size="small" @click="delClick(row)"
          >删除</h-button
        >
      </template>
    </h-table>
    <div class="btn">
      <h-button type="danger" @click="clone()">取消</h-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  computed,
  ref,
} from "vue";
import { Search } from "@element-plus/icons-vue";
import {
  analysisdetail,
  analysisBatchdelete,
} from "@/api/videoAnalysis/videoAnalysisApi.js";
import { ElMessageBox, ElMessage } from "element-plus";
export default defineComponent({
  name: "",
  components: { Search },
  props: {
    rowItem: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, context) {
    const state = reactive({
      val: ["1", "2", "3", "4"],
      tableData: [],
      options: [
        {
          label: "人体",
          value: "1",
        },
        {
          label: "机动车",
          value: "2",
        },
        {
          label: "非机动车",
          value: "3",
        },
        {
          label: "人脸",
          value: "4",
        },
      ],
      columns: [
        {
          type: "selection",
        },
        {
          type: "index",
        },
        {
          label: "设备名称",
          prop: "sourceName",
        },
        {
          label: "解析实况",
          slot: "analysisProgress",
          width: "400px",
        },
        {
          label: "下载状态",
          slot: "downloadStatus",
        },
        {
          label: "解析状态",
          slot: "analysisStatus",
        },
        {
          slot: "operate",
          label: "操作",
          width: "140px",
        },
      ],
      tableParams: {
        taskId: "555",
      },
      selectList: [],
    });
    const tableRef = ref(null);

    watchEffect(() => {
      state.tableParams.taskId = props.rowItem.id;
    });
    const refresh = (val) => {
      tableRef.value && tableRef.value.refresh();
    };
    const hzTableSelect = (val) => {
      state.selectList = val;
    };
    const delClick = (val) => {
      ElMessageBox.confirm(
        "此操作将删除解析数据且不可逆，请慎重考虑。",
        "确定要删除选中数据吗？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(
        async () => {
          deleteTask([val.id]);
        },
        () => {}
      );
    };
    const deleteTask = async (ids) => {
      const params = {
        ids: ids,
        sourceType: "3", //在线录像解析
      };
      const res = await analysisBatchdelete(params);
      if (res.code == 0) {
        ElMessage.success("操作成功");
        if (!res.page) {
          context.emit("cloe", "refresh");
          return;
        }
        refresh();
      }
    };
    const uploading = (val) => {
      context.emit("selectList", state.selectList);
    };
    const clone = (val) => {
      context.emit("cloe");
    };
    return {
      ...toRefs(state),
      delClick,
      clone,
      hzTableSelect,
      uploading,
      tableRef,
      analysisdetail,
    };
  },
});
</script>

<style lang="scss" scoped>
.el-form {
  display: flex;
  .el-form-item {
    margin: 0 5px;
  }
  .el-input {
    margin-left: 495px;
  }
}
.btn {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.table {
  height: 500px;
}
</style>
